import { render, staticRenderFns } from "./rekonpbbdb.vue?vue&type=template&id=65aed0cb&scoped=true"
import script from "./rekonpbbdb.vue?vue&type=script&lang=js"
export * from "./rekonpbbdb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aed0cb",
  null
  
)

export default component.exports